import React from "react";
import "./FullScreenLoading.css";

function FullScreenLoading() {
  return (
    <div className="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default FullScreenLoading;
